import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class UserApiClient extends BaseCRUDApiClient<UserDto> {
  baseUrl = this.config.apiEndpoint + '/user';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }

  getAllExt() {
    return this.http.post<{ users: UserDto[]; total: number }>(
      this.baseUrl,
      {},
    );
  }

  me() {
    return this.http.get<UserDto>(`${this.baseUrl}/me`);
  }

  resetPassword(id: string) {
    return this.http.put<void>(`${this.baseUrl}/${id}/reset-password`, {});
  }
}
